import { render, staticRenderFns } from "./edit_log.vue?vue&type=template&id=b5dd7c6a&"
import script from "./edit_log.vue?vue&type=script&lang=ts&"
export * from "./edit_log.vue?vue&type=script&lang=ts&"
import style0 from "./edit_log.vue?vue&type=style&index=0&id=b5dd7c6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports